import { render, staticRenderFns } from "./resellersV2.vue?vue&type=template&id=182f22b2&"
import script from "./resellersV2.vue?vue&type=script&lang=js&"
export * from "./resellersV2.vue?vue&type=script&lang=js&"
import style0 from "./resellersV2.vue?vue&type=style&index=0&id=182f22b2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports